<template>
  <div class="salesRecord-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" label-width="100px" :inline="true">
        <el-form-item :label="$t('manage.name86')" prop="tenantId" >
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%" clearable>
    <el-option
      v-for="item in tenantOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item>
        <el-form-item :label="$t('bike.name491')" prop="searchTime">
          <el-date-picker
            style="width:400px"
            v-model="searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-button type="primary" size="medium" @click="exportExcel" :loading="loading">{{ $t('manage.name60') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name29')" prop="createTime" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name452')" prop="storeAddress" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name451')" prop="userName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name458')" prop="saleDate" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name459')" prop="invoicePath" sortable>
        <template slot-scope="scope" v-if="scope.row.invoicePath">
          <el-image style="width: 50px; height: 50px" :src="scope.row.invoicePath" :preview-src-list="[scope.row.invoicePath]"></el-image>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { tenantList } from '@/api/manage.js'
import { querySaleRecordPage, exportEbikeSaleRecord } from '@/api/operate.js'
import { downloadExcel } from '@/utils/utils'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      tenantOptions: [],
      queryInfo: {
        pageSize: 10,
        pageNumber: 1,
        tenantId: '',
        permTenantList: [],
        startTime: '',
        endTime: ''
      },
      searchTime: [],
      tableLoading: false,
      loading: false,
      total: 0,
      tableList: []
    }
  },
  components: {},
  created() {
    // console.log('userinfo===', this.userinfo)
  },
  mounted() {
    this.loadOptions()
    this.getDataList()
  },
  methods: {
    loadOptions() {
      const data = { page: 1, limit: 500, tenantType: 2 }
      tenantList(data).then(res => {
        if (res.data.list) {
          this.tenantOptions = res.data.list.map(item => ({
            value: item.tenantId,
            label: item.tenantName
          }))
        } else {
          this.tenantOptions = []
        }
      }).catch(() => {})
    },
    getDataList() {
      this.tableLoading = true
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryInfo.permTenantList = []
      if (this.queryInfo.tenantId) {
        this.queryInfo.permTenantList.push(this.queryInfo.tenantId)
      }
      if (this.searchTime) {
        this.queryInfo.startTime = this.searchTime[0]
        this.queryInfo.endTime = this.searchTime[1]
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
      querySaleRecordPage(this.queryInfo).then(res => {
        if (res.code === 200) {
          this.tableList = res.data.page.records
          this.total = res.data.page.total
        } else {
          this.tableList = []
          this.total = 0
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    getSaleRecordPage() {
      if (this.searchTime) {
        this.queryInfo.startTime = this.searchTime[0]
        this.queryInfo.endTime = this.searchTime[1]
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
      this.tableLoading = true
      querySaleRecordPage(this.queryInfo).then(res => {
        if (res.code === 200) {
          this.tableList = res.data.page.records
          this.total = res.data.page.total
        } else {
          this.tableList = []
          this.total = 0
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    resetQuery() {
      this.queryInfo = {
        pageSize: 10,
        pageNumber: 1,
        tenantId: '',
        permTenantList: [],
        startTime: '',
        endTime: ''
      }
      this.searchTime = []
      this.getSaleRecordPage()
    },
    exportExcel() {
      this.loading = true
      exportEbikeSaleRecord(this.queryInfo)
        .then((res) => {
          this.loading = false
          downloadExcel(res, this.$t('tabmenu.name69'))
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getSaleRecordPage()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getSaleRecordPage()
    }
  }
}
</script>
<style lang="scss" scoped>
.salesRecord-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }
}
</style>
